import { shade } from 'polished';
import styled from 'styled-components';

export const Screen = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: space-between;

  overflow-y: scroll;

  width: 100vw;
  height: 100%;
  max-height: 100%;
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;

  width: 100%;
  height: 100%;
`;

export const Profile = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  width: 100%;
  height: 100%;
  max-height: 100%;
  padding: 3rem;
  /* border-left: 2px solid #e3e3e3; */

  background: #fff;
  /* box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px; */

  overflow-y: scroll;

  @media only screen and (max-width: 1600px) {
    padding: 2rem 1.5rem;
  }
`;

export const Me = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  position: relative;

  width: 100%;
  margin-bottom: 4rem;

  @media only screen and (max-width: 1500px) {
    margin-bottom: 2rem;
  }
`;

export const Language = styled.div`
  display: flex;
  align-items: flex-start;
  font-weight: bold;
  color: #051227;
  position: relative;
  cursor: pointer;
  z-index: 9999;
`;

export const LngList = styled.div`
  position: absolute;
  right: calc(0% + 1px);
  top: calc(20% + 5px);
  background: #fff;
  box-shadow: rgba(67, 71, 85, 0.27) 0px 0px 0.25em,
    rgba(90, 125, 188, 0.05) 0px 0.25em 1em;
  border-radius: 0.5rem;
  display: flex;
  flex-direction: column;

  padding: 0.75rem 0.5rem;

  p {
    border-radius: 0.5rem;
    transition: 0.3s ease-in-out;
    padding: 0.25rem 1rem;
    color: #051227;
    cursor: pointer;
    font-weight: 500;
  }

  p + p {
    margin-top: 0.25rem;
  }

  p:hover {
    background: #e5e8ee;
  }
`;

export const Details = styled.div`
  text-align: center;

  margin: 0 0.5rem;

  & > div {
    display: inline-flex;
    position: relative;

    /* padding: 1rem; */
    outline: 5px solid #1d62d1;
    outline-offset: 0.5rem;
    border-radius: 50%;
    box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
    margin-bottom: 1rem;
    align-items: center;
    justify-content: center;

    & > svg {
      color: #6f7380;
      padding: 1rem;
    }

    img {
      height: 80px;
      width: 80px;
      border-radius: 50%;
    }

    @media only screen and (max-width: 1500px) {
      outline-offset: 0.25rem;

      img {
        height: 60px !important;
        width: 60px !important;
      }
    }
  }

  p {
    font-size: 1.1rem;
    font-weight: 500;
    color: #051227;
    margin-top: 1rem;

    @media only screen and (max-width: 1500px) {
      margin-top: 0.5rem;
    }
  }

  @media only screen and (max-width: 1500px) {
    p {
      font-size: 1rem;
    }
  }
`;

export const NewAvtButton = styled.div`
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background: #f6ae2d;
  color: #fff;
  padding: 0.25rem;
  right: 0;
  bottom: 0;

  transition: 0.2s ease-in-out;
  cursor: pointer;

  &:hover {
    background: ${shade(0.3, '#f6ae2d')};
  }
`;

export const Levels = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  width: 100%;
  margin-bottom: 3.5rem;

  a {
    text-decoration: none;
  }

  > a {
    text-decoration: none;
    width: 100%;
  }

  a + a {
    margin-top: 1rem;
  }

  & > h4 {
    padding-bottom: 1rem;
    /* padding-left: 0.5rem; */
    color: #051227;
    font-weight: 600;
  }

  * {
    color: #6f7380;
  }

  div {
    a {
      display: inline-flex;
      align-items: center;

      border-radius: 2rem;
      background: blue;
      padding: 0.25rem 1rem;

      * {
        color: #fff !important;
      }

      p {
        margin-right: 1rem;
        font-weight: 500;
      }
    }
  }

  @media only screen and (max-width: 1500px) {
    margin-bottom: 1rem;

    & > h4 {
      font-size: 0.9rem;
      padding-bottom: 0.75rem;
    }
  }
`;

export const Level = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;

  width: 100%;
  padding: 0.75rem 0.5rem;
  border-radius: 1rem;

  background: #f6f7ff;

  transition: 0.2s ease-in-out;

  &:hover {
    background-color: #e8effa;
  }
`;

export const ShimmerLevel = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;

  width: 100%;
  padding: 0.75rem 0.5rem;
  border-radius: 1rem;

  background: #f6f7ff;

  transition: 0.2s ease-in-out;

  .cat-skeleton {
    width: 38px;
    height: 38px;
    border-radius: 1rem;
  }

  .row-skeleton {
    display: flex;
    width: 40%;
    height: 16px;

    border-radius: 0.5rem;
  }

  .progress-skeleton {
    width: 48px;
    height: 48px;
    border-radius: 50%;
  }
`;

export const LevelCat = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  width: 48px;
  height: 48px;
  border-radius: 1rem;

  background-color: #d2e0f6;
  box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px;

  @media only screen and (max-width: 1500px) {
    font-size: 0.85rem;
    width: 38px;
    height: 38px;
    border-radius: 0.75rem;
  }

  * {
    color: #1d62d1;
  }
`;

export const Name = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 40%;

  p {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #1e2a3d;
    font-size: 0.9rem;
    font-weight: 500;
    text-align: center;
  }

  @media only screen and (max-width: 1500px) {
    p {
      font-size: 0.75rem;
    }
  }
`;

export const Classes = styled.div`
  display: flex;
  flex-direction: column;

  width: 100%;

  & > h4 {
    padding-bottom: 1rem;
    padding-left: 0.5rem;
  }

  @media only screen and (max-width: 1500px) {
    & > h4 {
      padding-bottom: 0.75rem;
    }
  }
`;

export const ClassHeader = styled.div`
  display: flex;
  justify-content: space-between;

  width: 100%;
  margin-bottom: 1.5rem;

  & > h4 {
    color: #051227;
    font-weight: 600;
  }

  @media only screen and (max-width: 1500px) {
    & > h4 {
      font-size: 0.9rem;
    }
  }
`;

export const Box = styled.div`
  display: flex;
  flex-direction: column;
  flex: 0 1 auto;

  width: 100%;

  a {
    text-decoration: none;
  }

  div {
    a {
      display: inline-flex;
      align-items: center;

      border-radius: 2rem;
      background: blue;
      padding: 0.25rem 1rem;

      * {
        color: #fff !important;
      }

      p {
        margin-right: 1rem;
        font-weight: 500;
      }
    }
  }
`;

export const Class = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;

  width: 100%;
  padding: 0.75rem 0.5rem;
  border-radius: 1rem;

  background: #f6f7ff;
  color: #6f7380;

  transition: 0.2s ease-in-out;

  &:hover {
    background: #e8effa;
  }

  & > svg {
    margin-right: 0.5rem;
  }
`;

export const ShimmerClass = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;

  width: 100%;
  padding: 0.75rem 0.5rem;
  border-radius: 1rem;

  background: #f6f7ff;
  position: relative;

  .cat-skeleton {
    min-width: 38px;
    width: 38px;
    height: 38px;
    border-radius: 50%;
  }

  .row-skeleton {
    display: flex;
    height: 16px;

    border-radius: 0.5rem;
    flex: 1;
    margin: 0 1rem;
  }
`;

export const ClassIcon = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  min-width: 48px;
  width: 48px;
  height: 48px;
  border-radius: 50%;
  margin-right: 1rem;

  background-color: #d2e0f6;

  svg {
    color: #1d62d1;
  }

  @media only screen and (max-width: 1500px) {
    min-width: 38px;
    width: 38px;
    height: 38px;
  }
`;

export const ClassName = styled.div`
  display: flex;
  flex-direction: column;

  width: 100%;

  * {
    color: #0f3169;
  }

  p:first-child {
    font-weight: 500;
  }

  p:nth-child(2) {
    font-weight: 400;
  }

  @media only screen and (max-width: 1500px) {
    p {
      font-size: 0.9rem;
    }
  }
`;
